import { format } from 'date-fns';
import {
    GetMaintenanceListResponseDto,
    Maintenance,
    MaintenanceDto,
} from '../types/maintenance.types';

/**
 * LocalDateTime 배열 형식 또는 ISO 문자열 형식 모두 처리
 */
export const parseDate = (value: string | number[] | null | undefined): Date | null => {
    if (!value) return null;

    // 배열 형식: [2026, 1, 6, 13, 0, 0] (LocalDateTime 직렬화)
    if (Array.isArray(value)) {
        const [year, month, day, hour = 0, minute = 0, second = 0] = value;
        return new Date(year, month - 1, day, hour, minute, second);
    }

    // 문자열 형식: ISO 또는 다른 형식
    if (typeof value === 'string') {
        const parsed = new Date(value);
        if (!isNaN(parsed.getTime())) {
            return parsed;
        }
    }

    return null;
};

/**
 * 날짜값을 한국어 표시 형식으로 포맷
 */
export const formatDateTime = (dateValue: string | number[] | null): string => {
    if (!dateValue) return '-';
    try {
        const date = parseDate(dateValue as string | number[]);
        if (!date) return '-';
        return format(date, 'yyyy년 MM월 dd일 HH:mm');
    } catch {
        return String(dateValue);
    }
};

/** DTO → Domain 변환 */
export const maintenanceFromDto = (dto: MaintenanceDto): Maintenance => ({
    seqNo: dto.seqNo,
    startDate: parseDate(dto.startDate as unknown as string | number[]) || new Date(),
    endDate: parseDate(dto.endDate as unknown as string | number[]) || new Date(),
    msgCode: dto.msgCode,
    msgContent: dto.msgContent,
    useYn: dto.useYn,
    insUser: dto.insUser,
    insDate: parseDate(dto.insDate as unknown as string | number[]),
    updUser: dto.updUser,
    updDate: parseDate(dto.updDate as unknown as string | number[]),
});

/** 점검 목록 DTO → Domain 변환 */
export const maintenanceListFromDto = (dto: GetMaintenanceListResponseDto): Maintenance[] =>
    dto.maintenances.map(maintenanceFromDto);
